module.exports = __webpack_public_path__ + "media/images/lp_seiho/sec01_bg_01-43e88263f33bcdea86b5e1e09851d773.png";